import z from 'zod/v4';
export var ConnectConnectionStatus;
(function (ConnectConnectionStatus) {
    ConnectConnectionStatus["Active"] = "ACTIVE";
    ConnectConnectionStatus["Paused"] = "PAUSED";
    ConnectConnectionStatus["Disabled"] = "DISABLED";
})(ConnectConnectionStatus || (ConnectConnectionStatus = {}));
export const ConnectionOptions = z.object({
    sendInteractions: z.boolean().optional(),
    filterNonContactUsers: z.boolean().optional(),
});
export const CreateConnectConnectionSchema = z.object({
    fromTenantId: z.uuid(),
    fromCreditorId: z.uuid().optional(),
    toTenantId: z.uuid(),
    toCreditorId: z.uuid(),
    productId: z.uuid(),
    options: ConnectionOptions.optional(),
});
//# sourceMappingURL=index.js.map